var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[(_vm.isPaymentProcessor)?_c('transaction-search-box',{attrs:{"paymentId":_vm.paymentId}}):_c('div',[_vm._v("You do not have permission to access this website")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }